import { ReactNode } from "react";
import { Box } from "@mui/material";

/**
 * Two equal columns, on a grid rather than flexbox.
 *
 * With flexbox, a card whose content has a large minimum width — a table, typically — refuses
 * to shrink to half and steals space from its neighbour, so the gutter lands at a different
 * place on every row. Grid columns are `1fr 1fr` whatever the content holds, so every row on
 * the page shares the same gutter. Children carry `minWidth: 0` for the same reason: without
 * it, a grid item cannot shrink below its content either.
 */
const ChartRow = ({ children }: { children: ReactNode }) => (
  <Box
    sx={{
      display: "grid",
      gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
      gap: 2,
      alignItems: "stretch",
    }}
  >
    {children}
  </Box>
);

export default ChartRow;
